<div mat-dialog-title *ngIf="config.showHeader">
  <div
    class="mw-dialog__title text-headline-6"
    *ngIf="config.translations.title"
  >
    {{
      config.translations.title
        | translate : config.translations.title_params
        | mwTitleCase
    }}
  </div>
  <button
    mat-icon-button
    mat-dialog-close
    [disabled]="isCancelDisabled"
    class="mw-icon-button-32"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-divider
  *ngIf="(scrollable && config.showHeader) || config.showHeaderDivider"
  class="divider"
></mat-divider>

<div
  class="mat-dialog-content"
  mat-dialog-content
  #contentWrapper
  [class.mat-dialog-content--disable-scroll]="disableScroll"
>
  <div #customContent></div>
  <div
    #customText
    *ngIf="!config.customContentComponent"
    [innerHTML]="
      config.translations.text
        | translate : config.translations.text_params
        | mwTitleCase
    "
  ></div>
</div>

<mat-divider
  *ngIf="(scrollable && config.showFooter) || config.showFooterDivider"
  class="divider"
></mat-divider>

<mat-dialog-actions
  *ngIf="config.showFooter"
  class="actions-grid-container"
  [class.actions-on-right-grid-container]="config.showButtonsOnRightSide"
>
  <ng-template
    [ngTemplateOutlet]="
      additionalActionsTemplateRef || defaultAdditionalActionsTemplate
    "
  ></ng-template>

  <div class="flex-1" class="empty-col"></div>
  <mw-dialog-tertiary-button
    class="tertiary-btn"
    *ngIf="showTertiaryActions"
  ></mw-dialog-tertiary-button>
  <mw-dialog-cancel-button class="cancel-btn"></mw-dialog-cancel-button>
  <mw-dialog-confirm-button class="confirm-btn"></mw-dialog-confirm-button>
</mat-dialog-actions>

<ng-template #defaultAdditionalActionsTemplate>
  <mw-dialog-additional-button
    class="additional-btn"
    *ngIf="showAdditionalActions"
  ></mw-dialog-additional-button>
</ng-template>
